import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_checkeredflag: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-checkeredflag" {...rest}>
      <title>praise-checkeredflag</title>
      <ellipse
        transform="rotate(-88.267 74.997 75.003) scale(.99996)"
        fill="#F8AE41"
        cx="75"
        cy="75"
        rx="75"
        ry="75"
      ></ellipse>
      <path fill="#495361" d="M98.3 55.2h27.6v19.4H98.3z"></path>
      <path fill="#F5FAFA" d="M44.1 36.1h27.6v19.4H44.1z"></path>
      <path fill="#495361" d="M71.2 36.1h27.6v19.4H71.2z"></path>
      <path fill="#F5FAFA" d="M125.9 55.5H98.3V36.1h19.6c4.4 0 8 3.6 8 8v11.4z"></path>
      <path fill="#495361" d="M44.5 55.2h27.6v19.4H44.5z"></path>
      <path fill="#F5FAFA" d="M71.5 55.2h27.6v19.4H71.5zM44.1 74.6h27.6V94H44.1z"></path>
      <path fill="#495361" d="M71.2 74.6h27.6V94H71.2z"></path>
      <path fill="#F5FAFA" d="M118 94H98.3V74.6h27.6v11.5c0 4.4-3.6 7.9-7.9 7.9z"></path>
      <path
        fill="#495361"
        d="M43 130.5c-2.1 0-3.8-1.7-3.8-3.8V34.8c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8v91.9c0 2.1-1.7 3.8-3.8 3.8z"
      ></path>
    </svg>
  );
};
